export default __webpack_public_path__ + "static/screeny-110-gc-cabrio-description-1-697a70f984cddba245bc91e9d00cdf4d.jpg";